import React from 'react';
import ReactDOM from 'react-dom';
import Dict from 'dict-lib';
import LexemePage, {getPage} from './page/LexemePage';
import {LanguageTypeahead} from './../dict-components/typeahead/LanguageTypeahead';
import {LanguageTypeAheadTypes, LexemeEditingLevel, LexemeUtilities} from './page/editor/LexemeHelper';
import {Modal, Button, Col, Row, InputGroup, FormControl} from 'react-bootstrap';
import {EntryExternalDictionary} from "./page/editor/entry/EntryExternalDictionary";
import stylesSearchMenu from './../_css/dictionary/searchMenu.module.css';
import stylesLexemeTitle from "../_css/dictionary/lexemeParts/lexemeTitle.module.css";

export class StandaloneEntryExternalDictionary extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showExternalDictionary: true
        };

        this._close = this._close.bind(this);
    }

    _close() {
        this.setState({showExternalDictionary: false}, function () {
            this.emptyModalContainer();
        });
    }

    emptyModalContainer() {
        setTimeout(function () {
            ReactDOM.unmountComponentAtNode(document.getElementById('dict-modal-external-entry-container'));
        }, 500);
    }

    render() {
        return <Modal
            id={'dict-modal-external-entry'}
            show={this.state.showExternalDictionary}
            dialogClassName={stylesSearchMenu['dict-external-entry__dialog-modal']}
            onHide={() => {this._close()}}
            restoreFocus>
            <Modal.Header closeButton/>
            <Modal.Body bsClass={stylesSearchMenu['dict-external-entry__body']}>
                <EntryExternalDictionary
                    isStandalone={true}
                    pageStatus={this.props.pageStatus}
                    context={this.props.context}
                />
            </Modal.Body>
        </Modal>
    }
}